import { ICON_AGENCIES, ICON_CALENDAR } from "common/constants";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";

const AssessmentItem = ({
  data,
  index,
  entityType,
}: {
  data: any;
  index: number;
  entityType: string;
}) => {
  const details = [
    data?.updatedAt &&
      moment(new Date(data.updatedAt)).format("ddd, DD MMM, Y"),
    data?.contractor &&
      `<span class="fw-medium">Contractor:</span> ${data?.contractor || ""}`,
    data?.agency && `<span class="fw-medium">Agency:</span> ${data?.agency}`,
    data?.serialNumber &&
      `<span class="fw-medium">Serial Number:</span> ${data?.serialNumber}`,
    data?.overallRiskRating &&
      `<span class="fw-medium">Overall Risk Rating:</span> ${data?.overallRiskRating}`,
    data?.overallRating &&
      `<span class="fw-medium">Overall Rating:</span> ${data.overallRating}`,
  ].filter(Boolean);

  const detailsString = useMemo(() => details.join(", "), [details]);
  const componentId = React.useMemo(
    () =>
      `assessment-item-${
        data?.id || Math.random().toString(36).substring(2, 9)
      }`,
    [data?.id]
  );

  return (
    <div className={index === 0 ? "pb-3" : "py-3"} id={componentId}>
      <style>
        {`
          #${componentId} em {
            background-color: #fff59d;
            font-style: normal;
            padding: 0 0px;
            border-radius: 2px;
            font-weight: 500;
          }
        `}
      </style>
      <h5 className="mb-1">
        {entityType === "risk-assessment" && (
          <Link to={`/assessments/risk-assessments/${data?.id}`}>
            <span
              dangerouslySetInnerHTML={{
                __html: data?.reportTitle || data?.title || "",
              }}
            ></span>
          </Link>
        )}
        {entityType === "capacity-assessment" && (
          <Link to={`/assessments/capacity-assessments/${data?.id}`}>
            <span
              dangerouslySetInnerHTML={{
                __html: data?.reportTitle || data?.title || "",
              }}
            ></span>
          </Link>
        )}
        {entityType === "partner-verification-report" && (
          <Link to={`/assessments/pvrs/${data?.id}`}>
            <span
              dangerouslySetInnerHTML={{
                __html: data?.reportTitle || data?.title || "",
              }}
            ></span>
          </Link>
        )}
      </h5>
      <p className="text-success mb-2">
        {entityType === "risk-assessment" && "Risk Assessment"}
        {entityType === "capacity-assessment" && "Capacity Assessment"}
        {entityType === "partner-verification-report" &&
          "Partner Verification Report"}
      </p>
      <p
        className="text-muted mb-2"
        dangerouslySetInnerHTML={{ __html: `... ${detailsString} ...` }}
      ></p>
      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item me-3">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">
                {" "}
                {moment(new Date(data?.updatedAt)).format("DD MMM Y")}
              </span>
            </div>
          </div>
        </li>
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_AGENCIES}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">{data?.agency}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default AssessmentItem;
